import { toApiClientError, unwrap } from '../http.js';
function isRejection(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const body = value;
    return (typeof body['error'] === 'string' &&
        (body['redirectTo'] === null || typeof body['redirectTo'] === 'string'));
}
function outcome(result) {
    if (result.response.status === 400 && isRejection(result.error)) {
        return { ok: false, rejection: result.error };
    }
    if (!result.response.ok)
        throw toApiClientError(result.response, result.error);
    return { ok: true, value: unwrap(result) };
}
export function createOAuthApi(client) {
    return {
        async getAuthorizationRequest(query) {
            return outcome(await client.GET('/v1/oauth/authorize/request', { params: { query } }));
        },
        async decide(body) {
            return outcome(await client.POST('/v1/oauth/authorize', { body }));
        },
    };
}
//# sourceMappingURL=oauth.js.map